// The debounce function receives our function as a parameter
const debounce = ( fn ) => {
	// This holds the requestAnimationFrame reference, so we can cancel it if we wish
		let frame;

		// The debounce function returns a new function that can receive a variable number of arguments
		return ( ...params ) => {
		// If the frame variable has been defined, clear it now, and queue for next frame
			if ( frame ) {
				cancelAnimationFrame( frame );
			}

			// Queue our function call for the next frame
			frame = requestAnimationFrame( () => {
			// Call our function and pass any params we received
				fn( ...params );
			} );
		};
	},

	// Reads out the scroll position and stores it in the data attribute
	// so we can use it in our stylesheets
	storeScroll = () => {
		document.documentElement.dataset.scroll = window.scrollY;
	};

// Listen for new scroll events, here we debounce our `storeScroll` function
document.addEventListener( 'scroll', debounce( storeScroll ), { passive: true } );

// Update scroll position for first time
storeScroll();

/**
 * Modifies ghostkit config.
 *
 * @package golfnow-pro
 */
jQuery( document ).on( 'beforeInitSR.ghostkit', function( evt, classObject, element, config ) {
	config.viewFactor = 0.4;
} );

/**
 * Scroller targets and scrolls to anchors.
 *
 * @package golfnow-pro
 */

( function( $ ) {
	const Scroller = {

		/**
		 * DOM elements used.
		 */
		el: {},

		/**
		 * Initialize all the things.
		 *
		 * @return {void}
		 */
		init: function() {
			Scroller.el = {
				scroller: $( '.site-inner a[href^="#"]' ),
				offset: $( '.site-header' ).height(),
			};

			Scroller.bind_actions();
		},

		/**
		 * Binds the actions.
		 *
		 * @return {void}
		 */
		bind_actions: function() {
			Scroller.el.scroller.click( Scroller.scrollTo );
		},

		/**
		 * Initiates the scroll event.
		 *
		 * @param {Event} e The event.
		 * @return {boolean} False.
		 */
		scrollTo: function( e ) {
			var offset = Scroller.el.offset,
				speed = 2000;

			Scroller.el.target = $( $( this ).attr( 'href' ) );

			if ( 0 === Scroller.el.target.length ) {
				return true;
			}

			$( [ document.documentElement, document.body ] ).animate( {
				scrollTop: Scroller.el.target.offset().top - offset,
			}, speed );

			e.preventDefault();
			return false;
		},

	};

	$( document ).ready( function() {
		Scroller.init();
	} );
} )( jQuery );
